import posthog from 'posthog-js';

const key = process.env.REACT_APP_POSTHOG_KEY;
const host = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';
const disabled = process.env.REACT_APP_POSTHOG_DISABLED === 'true';

/**
 * Derive the logical environment name from the current hostname so every
 * PostHog event is tagged with it. Filter by environment in the PostHog UI.
 */
export function getEnvironment() {
  const hostname = globalThis.location?.hostname ?? '';
  if (hostname === 'app.occy.com') return 'production';
  if (hostname === 'demo.occy.co.uk') return 'demo';
  if (hostname === 'app-stage.occy.co.uk') return 'staging';
  if (hostname === 'app-dev.occy.co.uk') return 'development';
  if (hostname === 'localhost' || hostname.startsWith('127.')) return 'local';
  return 'unknown';
}

/**
 * Initialise PostHog once. Safe to call multiple times — subsequent calls are
 * no-ops because posthog-js guards against re-init.
 */
export function initPostHog() {
  if (!key || disabled) return;

  posthog.init(key, {
    api_host: host,

    // Track every client-side navigation in this React Router SPA without
    // requiring a full page reload.
    capture_pageview: 'history_change',

    // Capture unhandled JS errors and promise rejections as PostHog events so
    // they appear alongside session replays and product funnels.
    capture_exceptions: true,

    // Session replay: disabled at init so nothing records until PostHogUserSync
    // calls startSessionRecording (non-public routes, or any route when logged in).
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: '[data-ph-mask]',
    },

    // Keep PostHog state in localStorage under a prefixed key so it does not
    // collide with the app's own occyLs namespace.
    persistence: 'localStorage+cookie',
    persistence_name: '__ph_occy',

    // Respect the browser's Do Not Track signal.
    respect_dnt: true,

    loaded: (ph) => {
      // Tag every event with the environment so you can filter by env in
      // the PostHog UI (e.g. environment = production, staging, demo).
      ph.register({ environment: getEnvironment() });

      if (process.env.NODE_ENV === 'development') {
        ph.debug();
      }
    },
  });
}

export default posthog;
